"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var hooks_1 = require("@nef/hooks");
var styled_components_1 = require("styled-components");
var FormInput_1 = __importStar(require("../FormInput"));
var FormBaseInput_1 = __importDefault(require("../components/FormBaseInput"));
var FormInputGroup_1 = __importDefault(require("../components/FormInputGroup"));
var FormInputIcon_1 = __importDefault(require("./components/FormInputIcon"));
var FormFieldWithIcon = react_1.default.forwardRef(function (_a, ref) {
    var addonType = _a.addonType, className = _a.className, id = _a.id, label = _a.label, onChange = _a.onChange, optional = _a.optional, invalid = _a.invalid, feedback = _a.feedback, helpText = _a.helpText, iconSetClassName = _a.iconSetClassName, iconClassName = _a.iconClassName, disabled = _a.disabled, onIconClick = _a.onIconClick, plaintext = _a.plaintext, rtl = _a.rtl, size = _a.size, type = _a.type, props = __rest(_a, ["addonType", "className", "id", "label", "onChange", "optional", "invalid", "feedback", "helpText", "iconSetClassName", "iconClassName", "disabled", "onIconClick", "plaintext", "rtl", "size", "type"]);
    var themeRtl = react_1.default.useContext(styled_components_1.ThemeContext).rtl;
    var fieldRef = react_1.useRef(null);
    var handleIconClick = function (event) {
        if (onIconClick) {
            onIconClick(event);
        }
        if (fieldRef === null || fieldRef === void 0 ? void 0 : fieldRef.current) {
            fieldRef.current.focus();
        }
    };
    return (react_1.default.createElement(FormBaseInput_1.default, { className: className, feedback: feedback, helpText: helpText, id: id, invalid: invalid, label: label, optional: optional, rtl: themeRtl || rtl },
        react_1.default.createElement(FormInputGroup_1.default, { type: type, rtl: themeRtl || rtl, plaintext: plaintext },
            react_1.default.createElement(FormInputIcon_1.default, { addonType: addonType, iconClassName: iconClassName, iconSetClassName: iconSetClassName, "$rtl": themeRtl || rtl, size: size, onClick: handleIconClick }),
            react_1.default.createElement(FormInput_1.default, __assign({}, props, { size: size, className: className, disabled: disabled, id: id, invalid: invalid, onChange: FormInput_1.customChangeEvent(onChange), ref: hooks_1.useCombinedRefs(fieldRef, ref), rtl: themeRtl || rtl, plaintext: plaintext })))));
});
FormFieldWithIcon.displayName = "FormFieldWithIcon";
exports.default = FormFieldWithIcon;
//# sourceMappingURL=index.js.map